import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ChatbotConfig } from '@shared/index';
import { AdminService } from '@shared-angular/services/admin.service';

export const templateResolver: ResolveFn<ChatbotConfig[]> = async () => {
  const adminService = inject(AdminService);
  return await adminService.loadTemplateBots();
};
